<template>
  <CustomHeaderModal
    :isShowModal="isShowModal"
    @cancel="cancel">
    <!-- ヘッダー -->
    <header class="card-header">
      <div class="cover-filter">
        <p class="card-header-title">
          {{titleList[index]}}
        </p>
        <!-- <div v-if="index != 0">
          <button class="button nav-button" @click="changePage(-1)">{{getPageName(index, -1)}}</button>
          <button class="button nav-button" @click="changePage(1)" >{{getPageName(index,  1)}}</button>
        </div> -->
      </div>
    </header>
    <!-- 詳細 メイン -->
    <template v-if="index === 0">
      <div class="create-menu">
        <div class="left-box">
          <h2 class="cb-title">{{chatbot.name}}</h2>
          <img class="img-icon" :src="getIconURL(chatbot)">
        </div>
        <!-- <div class="right-box">
          <h2 class="category" v-if="storesInCategory">
            カテゴリ
            <span class="tag is-primary -left-8px">{{storesInCategory.category_title}}</span>
          </h2>
          <b-message type="is-info" has-icon>
            下記のボタンより本ロボのパーツ内訳、プレビューなどがご覧いただけます。<br>
            「雇用する」を押下致しますとロボが雇用され、パーツ編集画面へ遷移いたします。
          </b-message>
        </div> -->
        <div class="footer-box">
          <!-- <button class="button nav-button" @click="changePage(-1)">
            {{getPageName(index, -1)}}
          </button>
          <button class="button nav-button" @click="changePage(1)" >
            {{getPageName(index,  1)}}
          </button> -->
          <button class="button is-primary" @click="clickCreateChatBot()">
            雇用する
          </button>
        </div>
      </div>
    </template>
    <!-- 詳細 パーツリスト -->
    <template v-else-if="index === 1">
      <DetailPartsList
        :type="'store'"
        :chatbot="chatbot"
      />
    </template>
    <!-- 詳細 パーツプレビュー -->
    <template v-else>
      <DetailPartsPreview
        :type="'store'"
        :chatbot="chatbot"
      />
    </template>
  </CustomHeaderModal>
</template>

<script>
import CustomHeaderModal  from '@/components/Modals/CustomHeaderModal'
import DetailPartsList    from '@/components/ChatBot/organisms/DetailPartsList'
import DetailPartsPreview from '@/components/ChatBot/organisms/DetailPartsPreview'
export default {
  components: {
    CustomHeaderModal,
    DetailPartsList,
    DetailPartsPreview,
  },
  props: {
    isShowModal: {
      type: Boolean,
      required: true
    },
    chatbot: {
      type: Object,
      required: true
    },
    storeCategory: {
      type: Array,
      required: true
    }
  },
  computed: {
    storesInCategory () {
      let res = null
      for (const store of this.storeCategory) {
        if (store.category_id === this.chatbot.category) {
          res = store
        }
      }
      return res
    },
  },
  data () {
    const titleList = [
      'ロボ詳細画面 操作',
      'ロボ詳細画面 パーツ一覧',
      'ロボ詳細画面 パーツプレビュー'
    ]
    const miniTitleList = [
      '操作　画面へ',
      'パーツ一覧へ',
      'プレビューへ'
    ]
    return {
      index: 0,
      titleList: titleList,
      miniTitleList: miniTitleList,
    }
  },
  methods: {
    // icon 表示
    getIconURL (chatbot) {
      if (chatbot.icon_data) {
        return chatbot.icon_data
      } else {
        return require('@/assets/template/robot.png')
      }
    },
    cancel () {
      this.$emit('cancel', false)
    },
    changePage (delta) {
      const len = this.titleList.length
      const changeNum = this.index + delta
      if (changeNum === len) {
        // 超えたら最初に
        this.index = 0
      } else if (changeNum === -1) {
        // マイナスになったら最大へ
        this.index = len - 1
      } else {
        this.index = changeNum
      }
    },
    getPageName (index, delta) {
      const len = this.miniTitleList.length
      const changeNum = index + delta
      let idxStr = 0
      if (changeNum === len) {
        // 超えたら最初に
        idxStr = 0
      } else if (changeNum === -1) {
        // マイナスになったら最大へ
        idxStr = len - 1
      } else {
        idxStr = changeNum
      }
      return this.miniTitleList[idxStr]
    },
    clickCreateChatBot () {
      this.$emit('clickCreateChatBot', this.chatbot)
    },
  }
}
</script>

<style lang="scss" scoped>
.cover-filter {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  .card-header-title {
    font-size: 24px;
    font-weight: 600;
  }
  .nav-button {
    color: #a22;
    border: solid 2px #a22;
    font-weight: 800;
  }
  div {
    display: flex;
    button {
      margin: 8px;
    }
  }
}

.create-menu {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  width: 100%;
  padding: 24px;
  .left-box {
    width: 200px;
    text-align: center;
    .cb-title {
      font-size: 18px;
      font-weight: 600;
      color: #a22;
      margin-bottom: 8px;
    }
    .img-icon {
      width: 150px;
      height: 150px;
      object-fit: cover;
      margin-bottom: 16px;
      border: solid thin #ccc;
      border-radius: 50%;
    }
  }
  .right-box {
    width: calc(100% - 200px);
    .category {
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 16px;
    }
  }
  .footer-box {
    border-top: solid thin #ccc;
    width: 100%;
    padding: 16px;
    padding-bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    button {
      width: 30%;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/ChatBot/organisms/ModalChatBotCreateDetails.vue